var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['avatar', _vm.type],style:(_vm.computedStyle)},[(_vm.hasImage)?_c('div',{staticClass:"image",style:(_vm.computedImageStyle)}):_vm._e(),(_vm.letter)?_c('div',{staticClass:"letter",domProps:{"innerHTML":_vm._s(_vm.letter)}}):(_vm.type == 'company')?_c('Icon',{attrs:{"name":"company"}}):_c('Icon',{attrs:{"name":"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }